import * as React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Layout } from "../components/Layout";
import { Header } from "../components/guide/Header";
import {
  Footer,
  Content as FooterContent,
  Text as FooterText,
  Bye as FooterBye,
} from "../components/guide/Footer";
import { TheEnd } from "../components/gif/TheEnd/TheEnd";
import { About3 } from "../components/guide/About";
import { TitleGreen, Wave } from "../components/guide/Stream/styled";
import { SafeKids } from "../components/SafeKids/SafeKids";
import { ReadMore } from "../components/ReadMore";

import { Wrapper } from "../components/Wrapper";
import { Half, HalfWrap, Picture, TwoOne } from "../components/Layout/Layout";
import {
  Card as InfoCard,
  Title as InfoTitle,
  Description as InfoDescription,
  Image as InfoImage,
  ImageAdaptive as InfoImageAdaptive,
  Header as InfoHeader,
} from "../components/Cards/InfoCard";
import {
  Card as TypeCard,
  Title as TypeTitle,
  Description as TypeDescription,
  Picture as TypePicture,
} from "../components/Cards/TypeCard";
import {
  Card as ActionCard,
  Title as ActionCardTitle,
  Button as ActionCardButton,
} from "../components/Cards/ActionCard";
import { desktop, mobile } from "../theme";
import { Lead, Description } from "../components/Typography";
import { Platform } from "../components/Platform";

import image1Src from "../images/guide/4/image1.gif";
import image2Src from "../images/guide/4/image2.gif";
import image3Src from "../images/guide/4/image3.gif";
import image4Src from "../images/guide/4/image4.gif";
import image5Src from "../images/guide/4/image5.gif";
import image6Src from "../images/guide/4/image6.gif";
import image7Src from "../images/guide/4/image7.gif";
import image8Src from "../images/guide/4/image8.gif";
import image9Src from "../images/guide/4/image9.gif";
import image10Src from "../images/guide/4/image10.gif";
import image11Src from "../images/guide/4/image11.gif";
import image12Src from "../images/guide/4/image12.gif";
// import image13Src from "../images/guide/4/image13.gif";
import image14Src from "../images/guide/4/image14.gif";
import image15Src from "../images/guide/4/image15.gif";
import image16Src from "../images/guide/4/image16.gif";
import image17Src from "../images/guide/4/image17.gif";
import image18Src from "../images/guide/4/image18.gif";
import image19Src from "../images/guide/4/image19.gif";
import image20Src from "../images/guide/4/image20.gif";
import image21Src from "../images/guide/4/image21.gif";
import image22Src from "../images/guide/4/image22.gif";
import image23Src from "../images/guide/4/image23.gif";
import image24Src from "../images/guide/4/image24.gif";
import image25Src from "../images/guide/4/image25.gif";
import image26Src from "../images/guide/4/image26.gif";
import musthave1Src from "../images/guide/4/musthave/1.svg";
import musthave2Src from "../images/guide/4/musthave/2.svg";
import musthave3Src from "../images/guide/4/musthave/3.svg";
import musthave4Src from "../images/guide/4/musthave/4.svg";
import { Blog } from "../components/Blog";
import {
  quoteImages,
  quoteImagesSrcSet,
} from "../components/guide/Stream/3/WhatsWatch/Quote";

const Guide = styled("main")(
  css({
    background: "linear-gradient(90deg, #7CFD34 0%, #1BC6AF 100%)",
    position: "relative",
    zIndex: 0,
    overflow: "hidden",
  })
);

const TwoOneHow = styled(TwoOne)(css({ mb: [30, 100] }));

const GuidePage = () => (
  <Layout>
    <Guide>
      <Header
        no={4}
        title="Гайд №4"
        subtitle="Как залипнуть вместе на семейном блоге/влоге"
      />
      <About3 src={image19Src}>
        <p>
          Пока все на расслабоне и на чиле из-за каникул, мы подготовили
          свеженький гайд для наших бумеров и зумеров. По классике завариваем
          чаёк и набираем вкусняшки. Пришло время залипнуть всей семьей на
          БЛОГЕ/ВЛОГЕ!
        </p>
        <p>
          Ниже накидали символов для бумеров, а ты, наш маленький зумер, пока
          залипни на новом выпуске канала “А4”.
        </p>
      </About3>

      <Wrapper css={css({ position: "relative", [mobile]: { mt: 30 } })}>
        <Wave />
        <Half
          css={css({
            [desktop]: {
              mt: 180,
              mb: 75,
            },
          })}
        >
          <InfoCard>
            <InfoImageAdaptive src={musthave4Src} />
            <InfoTitle>Что такое блог?</InfoTitle>
            <InfoDescription>
              По факту, блог - это онлайн-дневник, который вы ведёте на
              постоянной основе. В нём может быть не только текст, также вы
              можете его разбавлять видосами, картинками и гифками… Или
              джифками, решайте сами! Для понимания это знаменитый ЖЖ (живой
              журнал), но он уже не развивается, а вот альтернатив куча. О них
              чуть ниже.
            </InfoDescription>
          </InfoCard>
          <InfoCard>
            <InfoImageAdaptive src={musthave2Src} />
            <InfoTitle>Что такое влог?</InfoTitle>
            <InfoDescription>
              Это тоже самое, только в видеоформате. Тот же самый
              онлайн-дневник, только вместо текста и фотографий автор общается с
              фолловерами через видео. В этом есть как плюсы, так и минусы.
            </InfoDescription>
          </InfoCard>
        </Half>

        <Lead>
          Раз уж мы пришли к общему знаменателю по обоим понятиям, то пора
          вернуть нашего зумера и фундаментально залипнуть всем вместе на этом
          гайде! Приятного скроллинга!
        </Lead>

        <Half>
          <ActionCard>
            <ActionCardTitle>Как создавать свой блог/влог.</ActionCardTitle>
            <ActionCardButton as="a" href="#how-create">
              Перейти
            </ActionCardButton>
          </ActionCard>
          <ActionCard>
            <ActionCardTitle>
              На каком блоге/влоге залипнуть всей семьёй. Свежая подборочка.
            </ActionCardTitle>
            <ActionCardButton as="a" href="#what-look">
              Перейти
            </ActionCardButton>
          </ActionCard>
        </Half>

        <div style={{ position: "relative" }}>
          <Wave />
          <TitleGreen id="how-create">Как создать свой блог/влог?</TitleGreen>
          <TwoOneHow>
            <Description>
              <h3>Зачем создавать блог/влог?</h3>
              <p>
                Прежде чем что-то создать, надо осознать зачем тебе это нужно.
                Авторами блога/влога становятся люди с желанием что-то
                рассказать своим знакомым, родным и близким! О своей работе,
                хобби или жизни в целом.
              </p>
              <p>
                Некоторые таким образом общаются, знакомятся, находят друзей по
                интересам, потому что люди очень социальные существа. Не надо
                забывать, что это не просто дневник, который тебя просит вести
                психолог или коучер лидерской программы! Прежде всего, это
                творчество.
              </p>
              <p>
                Уже видим как вся семья закатила глаза с мыслью “Кому мы тут
                интересны”. Это не так, поэтому возвращайте глаза на место!
                Каждый человек индивидуален и интересен!
              </p>
              <p>
                Помимо того, что вести блог не только интересное и совместное
                занятие, оно ещё может приносить доход. К слову, популярные
                блогеры в “Яндекс.Дзене” зарабатывают от 30 тыс. рублей!
              </p>
              <p>
                Люди просто пишут о своих кейсах на работе, лайфхаках в быту и
                школьной жизни. У всего этого всегда есть аудитория по смежным
                интересам с автором блога. Для успешного блога необходимо
                выбрать свою тему и задуматься над его подачей.
              </p>
            </Description>
            <Picture>
              <img alt="" src={image5Src} />
            </Picture>
          </TwoOneHow>
          <TwoOneHow>
            <Description>
              <h3>Как выбрать блог или влог?</h3>
              <p>
                Не любите писать много “букффф”? Ок. Заведите микро-блог в
                инсте. Здесь аудитория не любит много читать. Но тогда точно
                прочитайте книгу “Пиши и сокращай”, чтобы уложить максимум мысли
                в минимум слов.
              </p>
              <p>
                Кстати, авторы этой соц. сети поднимают гораздо больше голды чем
                ЖЖ и Дзен. Но тут надо выкладывать не только текст, но и
                красивые, завлекающие фото.
              </p>
              <p>
                А если совсем не хочется писать, то можете создать свой влог на
                YouTube и посвятить зрителей в свою интересную жизнь.
              </p>
              <p>
                Короче, чтобы начать вести блог/влог, необходимо определиться с
                его тематикой:
              </p>
            </Description>
            <Picture>
              <img alt="" src={image14Src} />
            </Picture>
          </TwoOneHow>
          <HalfWrap>
            <InfoCard>
              <InfoHeader>
                <img
                  alt=""
                  src={quoteImages[2]}
                  srcSet={quoteImagesSrcSet[2].join(", ")}
                />
                <h4>Бумерам</h4>
              </InfoHeader>
              <InfoDescription>
                Возьмите листок бумаги и ручку, напишите 10 категорий, в которых
                вы разбираетесь и о чём бы хотелось рассказать аудитории.
              </InfoDescription>
            </InfoCard>
            <InfoCard>
              <InfoHeader>
                <img
                  alt=""
                  src={quoteImages[1]}
                  srcSet={quoteImagesSrcSet[1].join(", ")}
                />
                <h4>Зумерам</h4>
              </InfoHeader>
              <InfoDescription>
                Возьми телефон, открой заметки и напиши темы, которые тебя
                интересуют и о чём ты знаешь больше, чем остальные.
              </InfoDescription>
            </InfoCard>
          </HalfWrap>
          <Lead>
            Теперь объединяем списки и выбираем общую тематику вашего
            блога/влога. А чтобы вам было проще написать свои списки, вот вам
            примеры.
          </Lead>
          <Description
            css={css({
              mb: [30, 55],
            })}
          >
            <h3>Какие типы блогов/влогов бывают?</h3>
          </Description>

          <HalfWrap>
            <TypeCard>
              <TypeTitle>Обзоры</TypeTitle>
              <TypePicture $src={image26Src} />
              <TypeDescription>
                Авторы делятся впечатлениями о покупках или услугах. Например,
                можно сделать обзор новой игрушки, кроссовок или похода всей
                семьёй в какое-то необычное место. Авторы делятся своими
                впечатлениями о товаре, услуге или о том, что попробовали.
                Посоветуют ли они “это” своим читателям или зрителям. Не
                забывайте, что больше всего люди ценят честность. В таких
                обзорах авторы часто ведут рейтинг: присваивают товарам или
                услугам оценки.
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Игры</TypeTitle>
              <TypePicture $src={image17Src} />
              <TypeDescription>
                Всегда были востребованы прохождения игр. Совместите полезное с
                приятным. Пройдя очередную миссию или найдя редкую пасхалку в
                игре, опишите весь процесс в своем блоге/влоге и дайте аудитории
                секретный ключик для прохождения, а она отблагодарит автора
                лайком и подпиской. Просто вбейте в поисковике “Прохождение
                миссии” и вы увидите сколько запросов ежедневно падает по этой
                теме.
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Читатели и обозреватели</TypeTitle>
              <TypePicture $src={image25Src} />
              <TypeDescription>
                Некоторые авторы делятся своими впечатлениями о прочитанных
                книгах. Многие каналы и личные блоги посвящены бестселлерам и
                приёмам писательского мастерства. Можно начать с видеообзора
                последней прочитанной книги или написать о том, что вы нашли
                новый смысл в известной книге.
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Обо всем понемногу</TypeTitle>
              <TypePicture $src={image20Src} />
              <TypeDescription>
                Многие считают, что просто писать или говорить о том, как прошёл
                день - это зашкварно и неинтересно. Пффффф…. А другие с
                удовольствием записывают свои мысли на камеру и набирают тонны
                подписоты и просмотров. Почему? Да потому что мы все похожи и
                всегда интересно услышать схожие мысли или мнение от другого
                человека. Такой тип ещё называют «в реальной жизни» (In Real
                Life). Очень простой формат для начала своего авторского пути.
                Поэтому и очень распространенный.
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Красота и мода</TypeTitle>
              <TypePicture $src={image7Src} />
              <TypeDescription>
                Согласитесь, что в одно время отовсюду мы слышали: бьюти-блог,
                бьютинг, бьюти фьюти, бьюти…. Это всё объяснимо. Если у человека
                есть вкус, свой стиль, он в этом искренне разбирается и кайфует
                от этого, то ему есть, что рассказать аудитории. Чувствуете в
                себе бьюти-начало? Экспериментируете с макияжем и отслеживаете
                модные тренды? Тогда срочно берём перо или телефон, чтобы
                написать/рассказать об этом своей аудитории, а там и другие
                подтянутся.
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Путешествия</TypeTitle>
              <TypePicture $src={image9Src} />
              <TypeDescription>
                В современном мире, перед тем как поехать куда-то в путешествие,
                мы обязательно посмотрим или почитаем обзоры этой страны или
                города. Почему бы вам, вернувшись из поездки, не поделиться
                своими эмоциями и лайфхаками? Или можно просто рассказать про
                отдых с семьей, школьную поездку и даже дорогу до школы!
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Для пользы дела</TypeTitle>
              <TypePicture $src={image1Src} />
              <TypeDescription>
                У каждого из нас есть свои увлечения или достижения на работе и
                в школе. Напишите об этом, расскажите всем как достигался
                результат, и что применялось для этого достижения. Например, вы
                знаете лайфхак как зумеру подтянуть английский или он освоил
                какое‑то занятие сам? Это точно будет интересно аудитории. Может
                у вас есть совместное занятие на выходных, которое вовлекает всю
                семью, а для кого-то это большая проблема. НЕ бойтесь делиться
                своими увлечениями - это отличный способ добиться успеха и
                собрать много поклонников.
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Масскультура</TypeTitle>
              <TypePicture $src={image16Src} />
              <TypeDescription>
                Любите кино, сериалы, мультфильмы или театр? Есть много авторов,
                которые делятся своим мнением о новинках кино, анимации или
                театральных постановок. Вы ничем не хуже и у вас есть своё
                мнение об этом. Если постоянно делать такого рода обзоры, то у
                вас обязательно появится своя аудитория.
              </TypeDescription>
            </TypeCard>
          </HalfWrap>

          <Description
            css={css({
              mt: [40, 80],
            })}
          >
            <h3>Всё понятно, а куда заливать творчество?</h3>
          </Description>
          <Lead>
            Прикладываем самые знаменитые и монетизируемые платформы{" "}
            <strong>для блогов</strong>:
          </Lead>

          <Platform
            url="https://www.livejournal.com/"
            title="LiveJournal"
            description="Живой Журнал, в народе просто ЖЖ — старейшая платформа для блогов в рунете, работает с конца девяностых."
            image={image24Src}
          >
            <h4>Функциональность:</h4>
            <ul>
              <li>
                Можно добавить в пост подзаголовки, врезки, цитаты, спойлеры,
                списки, ссылки, медиа из Instagram и др.
              </li>
              <li>
                Постинг по расписанию, кросспосты в Twitter, автосохранение.
              </li>
              <li>
                По запросам в поисковиках вас найдут, только если у вас большая
                аудитория.
              </li>
            </ul>
            <p>
              Топовые блогеры, которые давно набрали там огромную аудиторию,
              останутся и будут получать профит. Подойдет в том случае, если
              хотите просто попробовать: высказаться на одну из тем, посмотреть,
              как отреагируют читатели.
            </p>
          </Platform>
          <Platform
            url="https://zen.yandex.ru/"
            title="Яндекс.Дзен"
            description="Яндекс.Дзен — отечественная блог-платформа, которая интегрирована на главную страницу, в браузер и мобильное приложение Яндекса."
            image={image18Src}
          >
            <h4>Особенности:</h4>
            <ul>
              <li>
                Хороша для монетизации. Начинается после 10 000 минут просмотра
                статьи за последние 7 дней. Тут можно заработать на показах
                баннерной рекламы и на прямых нативных размещениях от других
                блогеров или брендов.
              </li>
              <li>
                Разнообразие форматов. Здесь не обязательно выкладывать только
                статьи. Нарративы, видеоролики и короткие посты тут тоже в
                почёте.
              </li>
              <li>
                Функциональный редактор. В Дзене можно разнообразить свой
                контент, добавив музыку, публикацию из Instagram и даже
                Яндекс.Карты.
              </li>
            </ul>
          </Platform>
          <Platform
            url="https://teletype.in"
            title="Teletype"
            description="Teletype — свежая отечественная блог-платформа с совместной работой над блогом."
            image={image22Src}
          >
            <h4>Возможности:</h4>
            <ul>
              <li>
                Совместная работа над блогом, разграничение доступов для
                авторов.
              </li>
              <li>Поиск по тегам, импорт из LiveJournal.</li>
              <li>Создание и ведение нескольких блогов от одного аккаунта.</li>
              <li>
                Настройка категорий для постов, превью для ссылки, кастомного
                URL для статьи.
              </li>
              <li>
                Удобный минималистичный визуальный редактор с автосохранением,
                добавлением кодов, разделителей, хештегов, YouTube-видео и др.
              </li>
            </ul>
          </Platform>
          <Platform
            url="https://vk.com/@authors-redaktor-statei1"
            title="VK"
            description="ВКонтакте порадовал авторов своим редактором статей VK. Здесь есть удобные инструменты для блогинга в соцмедиа."
            image={image4Src}
          >
            <h4>Возможности:</h4>
            <ul>
              <li>
                Автосохранение, черновики, настройка обложки и кастомного URL
                для публикации, Instant View.
              </li>
              <li>Темная тема и бесконечный скроллинг.</li>
              <li>
                Подробная статистика: открытия, прочтения в процентах, шеры.
              </li>
              <li>
                Удобный визуальный редактор, где можно указать подзаголовки,
                цитаты, добавить выделения, разделители, ссылки. Также прямо в
                статью вставляются опросы, музыка и видео VK.
              </li>
            </ul>
          </Platform>

          <Lead>
            А теперь поговорим о платформах <strong>для влога:</strong>
          </Lead>

          <Platform
            guideNo={3}
            guideImage={image6Src}
            guideText="Посмотри гайд «Как залипнуть вместе с ребенком на Youtube»"
            title="YouTube"
            description="Вы уже хорошо знакомы с этим популярным видеохостингом и одним из крупнейших комьюнити, если вы читали предыдущий гайд (ссылка), поэтому не будем заострять на нём внимание."
          />
          <Platform
            guideNo={2}
            guideImage={image12Src}
            guideText="Посмотри гайд «Как залипнуть вместе с ребенком на TikTok»"
            title="TikTok"
            description="Молодая, но очень популярная платформа, о которой мы рассказывали здесь. В TikTok делать динамичный влог, так как максимальная длительность загруженного видео всего 1 минута (у бОльшей части аудитории)."
          />
          <Platform
            image={image3Src}
            title="Instagram"
            description={
              <>
                Об этой платформе мы ещё не рассказывали, поэтому здесь мы
                задержимся.
                <br />
                Когда-то инста была верным помощником для постинга фотографий.
                Некоторые староверы до сих пор только этим и занимаются тут. Но
                более продвинутые юзеры постоянно кормят свою аудиторию влогами.
                Чего и вам желаем.
                <br />
                В обычном посте видео ограничено 59 секундами. Поэтому, если ваш
                поток творчества сильно больше, то не стоит ужимать его до
                минуты. Используйте IGTV (Instagram TV). Тут можно загружать
                видео длиной более 1 минуты.
                <br />
                Все видео надо заливать после монтажа, т.к. в инсте нету
                встроенного редактора. А если ты смелый ловкий и умелый (немного
                ностальжи для бумеров), то прямые эфиры тебя зовут. Причем их
                можно вести совместно с приглашенными гостями, а после сохранить
                в формате IGTV для тех, кто не успел посмотреть твой эфир.
              </>
            }
          />
          <Platform
            image={image10Src}
            title="Twitch"
            description={
              <>
                Любишь геймить? Тогда для тебя подойдет стриминговая площадка
                Twitch – именно здесь происходит весь движ, связанный с играми.
                Впрочем, никто не мешает тебе рассказывать в прямых эфирах о
                том, что нравится. Будешь делать это интересно - найдутся
                зрители. Кстати, если YouTube больше нравится, то там также
                можно стримить.
              </>
            }
          />
        </div>

        <div style={{ position: "relative" }}>
          <Wave />
          <TitleGreen id="what-look">
            На каком блоге/влоге залипнуть всей семьёй.
          </TitleGreen>
          <Description
            css={css({
              mb: [30, 0],
            })}
          >
            <h3>Свежая подборочка</h3>
          </Description>
          <Blog
            image={image2Src}
            url="http://zavodfoto.livejournal.com/"
            title="ZAVODFOTO.RU - ФотоБанк № 1 Промышленности России"
            source="LiveJournal"
          >
            Блог ведёт целая семья: Светлана, Игорь, дочка Лера и сын Стас.
            Живут они в Перми. В ЖЖ стараются собрать полную энциклопедию
            промышленности России. Основу блога составляют репортажи Игоря о
            заводах и фабриках. Светлана работает учителем в школе и водит на
            экскурсии юных «почемучек». Лера — студентка и футболистка. Стас
            дополняет репортажи папы детской непосредственностью.
          </Blog>
          <Blog
            image={image23Src}
            url="https://zen.yandex.ru/detidoma"
            title="Блог «Дети дома. Дети в школе.»"
            source="Яндекс.Дзен"
            subscribers="55 855"
            auditory="183 534"
          >
            Полезный канал, который расскажет сотни идей как вместе провести
            досуг, подобрать будущее образование и вообще изучить мир ребенка и
            родителей. Как усвоить сложный материал школьной программы?
            <br />
            Чем заняться на выходных?
            <br />
            Как разрешать конфликты?
            <br />
            Ответы на эти вопросы можно найти в этом блоге!
          </Blog>
          <Blog
            image={image11Src}
            url="https://zen.yandex.ru/ya_roditel"
            title="Блог «Я родитель»"
            source="Яндекс.Дзен"
            subscribers="6 146"
            auditory="12 479"
          >
            Блог “Я родитель” создан для ответственных мам и пап, которые
            стремятся найти общий язык со своими детьми и выстраивать здоровые и
            доверительные отношения друг с другом. В нем общие принципы
            воспитания и развития детей, психологические вопросы в жизни семьи.
            Если вы хотите вырастить достойного человека и личность, то этот
            канал будет в помощь.
          </Blog>
          <Blog
            image={image8Src}
            url="https://zen.yandex.ru/detidoma"
            title="Денис Кукояка"
            source="Instagram"
            subscribers="893 000"
          >
            Этот, уже семейный, влог не оставит равнодушных. Денис, Лена, дочь
            Василиса и пёс Федя снимают сериал Kukoyaka’s про всё, что
            происходит в их семье. День рождения Васи, семейные прогулки, пранки
            над Федей и всё, что может происходить в обычной семье, но под углом
            юмора.
          </Blog>
        </div>

        <div style={{ position: "relative" }}>
          <Wave />
          <TitleGreen>Musthave к прочтению!</TitleGreen>
          <TwoOne
            css={css({
              mb: [45, 55],
            })}
          >
            <Description>
              <p>
                При всём вышеизложенном не стоит забывать об информационной
                гигиене. Не для кого
              </p>
              <p>
                не секрет, что в наших и ваших этих интернетах есть как хорошее
                так и плохое. Не стоит дарить злоумышленникам повод для интереса
                к вашей жизни и достатку. Лучше предпринять меры
                предосторожности заранее, чем потом исправлять неисправимое.
                Поэтому надо соблюдать простые правила безопасности:
              </p>
            </Description>
            <Picture>
              <img alt="" src={image15Src} style={{ width: "100%" }} />
            </Picture>
          </TwoOne>
          <HalfWrap>
            <InfoCard>
              <InfoImage src={musthave1Src} />
              <InfoDescription>
                Не снимайте и не выкладывайте своё место жительства, не ставьте
                подробные геометки.
              </InfoDescription>
            </InfoCard>
            <InfoCard>
              <InfoImage src={musthave2Src} />
              <InfoDescription>
                Никогда не “палите” свои пароли и придумывайте новые сложные
                пароли: от 12 знаков и больше, используйте специальные символы
                типа^&@#, верхние регистры и цифры. И периодически меняйте
                пароли.
              </InfoDescription>
            </InfoCard>
            <InfoCard>
              <InfoImage src={musthave3Src} />
              <InfoDescription>
                Захотели снять влог о том, как получили свой новенький паспорт?
                Не стоит афишировать это и ещё некоторые данные: номера карт,
                фамилии, номера телефонов и прочее.
              </InfoDescription>
            </InfoCard>
            <InfoCard>
              <InfoImage src={musthave4Src} />
              <InfoDescription>
                Не забывайте про резервное копирование. На некоторых площадках
                есть такая функция, а если нет, то ctrl+с и ctrl+v на свой
                компьютер в безопасное место.
              </InfoDescription>
            </InfoCard>
          </HalfWrap>
        </div>
      </Wrapper>

      <Footer>
        <FooterContent>
          <TheEnd $src={image21Src} />
          <FooterText>
            А в конце этого гайда хочется сказать: не важно на чём вы залипаете.
            Главное, что вы залипаете всей семьёй! Цените время проведённое
            вместе и получайте от этого истинное наслаждение.
          </FooterText>
          <FooterBye>
            Обняли, приподняли и на место поставили! Всем BB!
          </FooterBye>
        </FooterContent>
      </Footer>
      <ReadMore without={4} />
      <SafeKids />
    </Guide>
  </Layout>
);

export default GuidePage;
